// fix vh shift on mobile
const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', documentHeight)
documentHeight()

// dynamically hide/show nav items on resize/load
const headerNavItemRights = [];
document.querySelectorAll('header.global nav > ul > li').forEach(elem => {
    headerNavItemRights.push(elem.getBoundingClientRect().right + 24)
})

function toggleHeaderNavItems(){
    headerNavItemRights.forEach((rightValue, index) => {
        const navItems = document.querySelectorAll('header.global nav > ul > li');
        //console.log(rightValue, window.innerWidth)
        if(rightValue > window.innerWidth){
            navItems[index].style.display = 'none';
        }else if(navItems[index].className !== 'wishlist' && navItems[index].className !== 'account'){
            navItems[index].style.display = 'block';
        }
    })
}

if(window.innerWidth > 1200){
    toggleHeaderNavItems();
}
window.addEventListener('resize', function(){
    if(window.innerWidth > 1200){
        toggleHeaderNavItems();
    }else{
        /* headerNavItemRights.forEach((_, index) => {
            const navItems = document.querySelectorAll('header.global nav > ul > li');
            if(window.innerWidth){

            }
            document.querySelectorAll('header.global nav > ul > li')[index].style.display = 'block';
        }) */
    }
});

// top nav menu hovers/taps
if(window.innerWidth <= 1200){
    document.querySelectorAll('header.global nav .parent > a').forEach(function(elem){
        elem.addEventListener('click', function(e){
            e.preventDefault();
            if(e.target.nextElementSibling.style.display == 'block'){
                e.target.nextElementSibling.style.display = 'none';
            }else{
                document.querySelectorAll('header.global nav .sub-nav, header.global nav .mega-menu').forEach(function(elem){
                    elem.style.display = 'none';
                })
                e.target.nextElementSibling.style.display = 'block'
            }
        })
    })

    document.querySelector('header.global .menu button').addEventListener('click', function(e){
        //console.log('display', document.querySelector('header.global nav').style.display)
        const navElement = document.querySelector('header.global nav');
        if(!navElement.style.display || navElement.style.display == 'none'){
            e.target.setAttribute('data-open', 'true');
            navElement.style.display = 'block';
            document.querySelector('body').style.overflow = 'hidden';
        }else{
            e.target.removeAttribute('data-open');
            navElement.style.display = 'none';
            document.querySelectorAll('header.global nav .sub-nav, header.global nav .mega-menu').forEach(function(elem){
                elem.style.display = 'none';
            })
            document.querySelector('body').style.overflow = 'auto';
        }
    })
}else{
    document.querySelectorAll('header.global nav > ul > li > a').forEach(elem => {
        elem.addEventListener('mouseenter', (e) => {
            //mouseenter nav item
            if(e.target.parentNode.className.indexOf('parent') !== -1){
                const menu = e.target.nextElementSibling;
                e.target.setAttribute('data-open', 'true')
                if(menu.className == 'mega-menu'){
                    menu.style.display = 'flex';
                }else{
                    menu.style.display = 'block';
                }
                //document.querySelector('#nav-overlay').style.display = 'block';
                document.querySelector('#nav-overlay').setAttribute('data-active', 'true');
            }else{
                //document.querySelector('#nav-overlay').style.display = 'none';
                document.querySelector('#nav-overlay').removeAttribute('data-active');
            }
        })
        //mouseleave nav item
        elem.addEventListener('mouseleave', (e) => {
            // if mouse is not on the parent, mega menu, or sub nav
            if(e.target.parentNode.className.indexOf('parent') !== -1
                && (
                    !e.relatedTarget
                    || (
                        e.relatedTarget.className !== 'mega-menu'
                        && e.relatedTarget.className !== 'sub-nav'
                    )
                )
            ){
                e.target.nextElementSibling.style.display = 'none';
                e.target.removeAttribute('data-open')
                //if they land on the nav ul don't remove overlay to prevent flashing
                if(e.relatedTarget && e.relatedTarget.nodeName !== 'UL'){
                    //document.querySelector('#nav-overlay').style.display = 'none';
                    document.querySelector('#nav-overlay').removeAttribute('data-active');
                }
            }
        })
    });

    // mouseleave dropdown
    document.querySelectorAll('header.global .mega-menu, header.global .sub-nav').forEach(elem => {
        elem.addEventListener('mouseleave', (e) => {
            if(e.target.style.display !== 'none'){
                // hide if hover is not over the trigger nav item
                if(!e.relatedTarget
                    || e.relatedTarget.getAttribute('href') !== e.target.previousElementSibling.getAttribute('href')
                ){
                    e.target.style.display = 'none';
                    e.target.previousElementSibling.removeAttribute('data-open')
                    //document.querySelector('#nav-overlay').style.display = 'none';
                    document.querySelector('#nav-overlay').removeAttribute('data-active');
                }
            }
        })
    })

    // make sure overlay goes away (if user hovers on ul and leaves)
    document.querySelectorAll('header.global nav > ul').forEach(elem => {
        elem.addEventListener('mouseleave', (e) => {
            /* if(document.querySelector('#nav-overlay').style.display !== 'none'){
                document.querySelector('#nav-overlay').style.display = 'none';
            } */
            if(document.querySelector('#nav-overlay[data-active="true"]')){
                document.querySelector('#nav-overlay').removeAttribute('data-active');
            }
        })
    })
}

// shorten search placeholder to fit better
if(window.innerWidth <= 480){
    document.querySelector('header.global .search input').setAttribute('placeholder', 'Search pain relief, electronics, and more...')
}

// scroll to correct url hash position, taking the header height into consideration
const targetTimer = setTimeout(() => {
    if(document.querySelector(':target')){
        const adjustedScrollTop = document.querySelector(':target').offsetTop - document.querySelector('header.global').clientHeight - 24
        document.querySelector('html').scrollTo(0, adjustedScrollTop)
        setTimeout(targetTimer)
    }
}, 100)

// button loading helper
function loadingState(btn, status){
    if(status === 'on'){
        btn.setAttribute('aria-disabled', true);
        btn.classList.add('loading');
        btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }else{
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
}